// extracted by css-extract-rspack-plugin
export default {"alert":"n8_DV9yajHIxNcTA","text":"dcCxGVovRUQsWkvg"};